import Vue from 'vue';
import Video from './Video.vue';
import SvgIcon from '../../common/Icon.vue';
Vue.component('svg-icon', SvgIcon);
// props有可能是来自客户端的参数，也有可能是来自编辑器的参数，
// 还可能是来自服务端渲染时html上的餐数
export default (props) => {
  /**
   * props中的参数
   * url 视频源链接
   * thumbnailUrl 视频的缩略图
   * status 视频的状态
   * attachmentId 视频的附件ID
   * enableJsbridge 视频的播放方式区分客户端
   * duration 视频的时长
   * filename 视频的文件名称
   * env 当前环境
   */
  const Constructor = Vue.extend(Video);
  const { url = '', thumbnailUrl = '', status = '', attachmentId = '', duration = 0, filename = '' } = props;
  const component = new Constructor({
    propsData: {
      ...props
    },
    data: {
      url,
      thumbnailUrl,
      status,
      attachmentId,
      duration,
      filename
    }
  });
  return { component };
};
